<template>
  <div class="app-container">
    <div class="left_pad">
      <div class="equip_info">
        <div class="pad_back">
          <div class="equip_num">{{ gdtotal.dbgd }}</div>
          <div class="equip_text">待办工单</div>
          <div class="equip_icon">
            <img
              src="../../assets/satistics/icon-todoorder.png"
              alt=""
              class="equip_icon_img"
            />
          </div>
          <div class="arrow_border_pad"></div>
        </div>
        <div class="pad_back">
          <div class="equip_num">{{ gdtotal.sbyjs }}</div>
          <div class="equip_text">设备预警数</div>
          <div class="equip_icon">
            <img
              src="../../assets/satistics/icon-warning.png"
              alt=""
              class="equip_icon_img"
            />
          </div>
          <div class="arrow_border_pad"></div>
        </div>
        <div class="pad_back">
          <div class="equip_num">{{ gdtotal.sblxs }}</div>
          <div class="equip_text">设备离线数</div>
          <div class="equip_icon">
            <img
              src="../../assets/satistics/icon-logout.png"
              alt=""
              class="equip_icon_img"
            />
          </div>
          <div class="arrow_border_pad"></div>
        </div>
      </div>

      <div class="first_pad" style="height: 80%; z-index: 500">
        <img
          src="../../assets/satistics/img-content-back.png"
          alt=""
          class="back_img"
        />
        <div class="pad_title">
          <span class="pad_title_text selected_title">设备状况</span>
        </div>
        <el-carousel
          height="90%"
          class="right_pic"
          v-if="photeList.length > 0"
          arrow="never"
          :autoplay="true"
          loop
          :interval="3000"
          @mouseenter.native="photeword2 = true"
          @mouseleave.native="photeword2 = false"
          style="
            position: absolute;
            top: 4rem;
            left: 50%;
            transform: translateX(-50%);
            height: 86%;
          "
        >
          <el-carousel-item
            style="height: 100%; width: 100%"
            v-for="(list, index2) in photeList"
            :key="index2"
          >
            <!-- <div class="suipaiword" :class="{ show: photeword2 == true }">
              {{ list.name }}
            </div> -->
            <el-image
              style="width: 100%; height: 100%"
              :src="list.url"
              :preview-src-list="[list.url]"
            >
            </el-image>
            <!-- <img style="height: 100%;width: 100%;" :src="baseUrl.replace('/biyi','/file') + list.url.replace('/upload','') + '/' + list.targetFileName" alt=""  @mouseover="photeword=true" @mouseout="photeword=false"> -->
          </el-carousel-item>
        </el-carousel>
        <div class="box" v-if="false">
          <div
            style="width: 100%; height: 100%; z-index: 1000"
            v-if="orderList.length > 0"
          >
            <info-list :data="orderList" type="环境监测"></info-list>
          </div>
          <div class="select_year">
            <el-select
              v-model="selectedMonth"
              class="month_picker"
              popper-class="month_selections"
              :popper-append-to-body="false"
              @change="getOrderList"
            >
              <el-option
                v-for="(item, index) in monthSelections"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
          </div>
          <div class="no_data" v-if="orderList.length == 0">
            <img
              src="../../assets/satistics/icon-no-order.png"
              alt=""
              class="no_data_img"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="center_pad">
      <infoPad2 height="95" :title="chosenTitle" @change="changeTitle">
        <div
          class="inner_pad"
          style="position: absolute; z-index: 100; margin-top: 0.6rem"
        >
          <div
            class="inner_left"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              overflow: hidden;
            "
            @mousedown="startDrag"
            @mousemove="onMouseMove"
            @mouseup="endDrag"
            @wheel="handleWheel"
          >
            <img
              src="../../assets/map/bg3.png"
              style="width: 100%; height: 100%; position: absolute; z-index: 1"
            />
            <!-- <ScreenMap
              ref="mapBox"
              :videoids="videoids"
              @handleView="handleView"
              style="position: absolute; z-index: 2; width: 94%; height: 94%"
            /> -->
            <img
              ref="image"
              src="../../assets/map/ditu2.png"
              alt=""
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                cursor: move;
                z-index: 2;
                width: 94%;
                height: 94%;
              "
            />
          </div>
          <img
            src="../../assets/map/topBg.png"
            style="width: 100%; position: absolute; z-index: 3; top: -1.5rem"
          />
          <img
            src="../../assets/map/leftBg.png"
            style="
              height: 100%;
              position: absolute;
              z-index: 3;
              left: -1.5rem;
              top: 0;
            "
          />
          <img
            src="../../assets/map/topBg.png"
            style="width: 100%; position: absolute; z-index: 3; bottom: -1.5rem"
          />
          <img
            src="../../assets/map/leftBg.png"
            style="
              height: 100%;
              position: absolute;
              z-index: 3;
              right: -1.5rem;
              top: 0;
            "
          />
          <!--          <div class="videodingwei" v-show="innerPic==1">-->
          <!--            <div class="videodw" v-for="(item ,index ) in videoids" :class="`dw`+index"-->
          <!--                 @click="handleView(item)"></div>-->
          <!--          </div>-->
        </div>
      </infoPad2>
    </div>

    <div class="right_pad">
      <div class="first_pad" style="height: 35%; z-index: 500">
        <img
          src="../../assets/satistics/img-content-back.png"
          alt=""
          class="back_img"
        />
        <div class="pad_title">
          <span class="pad_title_text selected_title">今日气象</span>
        </div>
        <div class="box2">
          <div class="weather_info" v-if="weatherInfo">
            <div class="info_line">
              <!-- <div class="info_item">
                 <div class="info_num"
                 >{{weatherInfo.lux||0}}
                 </div>
                 <div class="info_text">光照度</div>
                 <div class="info_text">(lx)</div>
               </div> -->
              <div class="info_item">
                <!--                pm2.5:小于50：绿色，50-100：淡绿色，100-150：黄色，150-200：橙色，200以上：红色-->
                <div
                  class="info_num"
                  :style="
                    weatherInfo.pm2_5 > 200
                      ? 'color:red'
                      : weatherInfo.pm2_5 > 150
                      ? 'color:orange'
                      : weatherInfo.pm2_5 > 100
                      ? 'color:yellow'
                      : weatherInfo.pm2_5 > 50
                      ? 'color:#BEF5CD'
                      : 'color:#61ff33'
                  "
                >
                  {{ weatherInfo.pm2_5 || 0 }}
                  <!--                  <span style="font-family: '微软雅黑';color: #fff;font-size: 16px;">({{weatherInfo.pm2_5>200?'重度污染':weatherInfo.pm2_5>150?'中度污染':weatherInfo.pm2_5>100?'轻度污染':weatherInfo.pm2_5>50?'良':'优'}})</span>-->
                </div>
                <div
                  class="info_text"
                  style="font-family: myDigib"
                  :style="
                    weatherInfo.pm2_5 > 200
                      ? 'color:red'
                      : weatherInfo.pm2_5 > 150
                      ? 'color:orange'
                      : weatherInfo.pm2_5 > 100
                      ? 'color:yellow'
                      : weatherInfo.pm2_5 > 50
                      ? 'color:#BEF5CD'
                      : 'color:#61ff33'
                  "
                >
                  {{
                    weatherInfo.pm2_5 > 200
                      ? "重度污染"
                      : weatherInfo.pm2_5 > 150
                      ? "中度污染"
                      : weatherInfo.pm2_5 > 100
                      ? "轻度污染"
                      : weatherInfo.pm2_5 > 50
                      ? "良"
                      : "优"
                  }}
                </div>
                <div class="info_text">pm2.5(ug/m³)</div>
              </div>
              <div class="info_item">
                <!--                pm10：大于50就标红-->
                <div
                  class="info_num"
                  :style="weatherInfo.pm10 > 50 ? 'color:red' : 'color:#61ff33'"
                >
                  {{ weatherInfo.pm10 || 0 }}
                </div>
                <div
                  class="info_text"
                  style="font-family: myDigib"
                  :style="weatherInfo.pm10 > 50 ? 'color:red' : 'color:#61ff33'"
                >
                  {{ weatherInfo.pm10 > 50 ? "超标" : "正常" }}
                </div>
                <div class="info_text">pm10(ug/m³)</div>
              </div>
              <div class="info_item">
                <div class="info_num">{{ weatherInfo.airpressure || 0 }}</div>
                <div class="info_text">气压</div>
                <div class="info_text">(hPa)</div>
              </div>
            </div>
            <div class="info_line">
              <div class="info_item">
                <!--                音量：小于40：安静，40-60：正常，大于60：吵闹-->
                <!--                音量：安静：绿色，正常：淡绿色，吵闹：橙色-->
                <div
                  class="info_num"
                  :style="
                    weatherInfo.noise > 60
                      ? 'color:orange'
                      : weatherInfo.noise > 40
                      ? 'color:#61ff33'
                      : 'color:#61ff33'
                  "
                >
                  {{ weatherInfo.noise || 0 }}
                </div>
                <div
                  class="info_text"
                  style="font-family: myDigib"
                  :style="
                    weatherInfo.noise > 60
                      ? 'color:orange'
                      : weatherInfo.noise > 40
                      ? 'color:#61ff33'
                      : 'color:#61ff33'
                  "
                >
                  {{
                    weatherInfo.noise > 60
                      ? "吵闹"
                      : weatherInfo.noise > 40
                      ? "正常"
                      : "安静"
                  }}
                </div>
                <div class="info_text">环境音量(DB)</div>
              </div>
              <div class="info_item">
                <div class="info_num" style="font-family: myDigib">
                  {{
                    weatherInfo.humidity
                      ? weatherInfo.humidity.substr(
                          0,
                          weatherInfo.humidity.length - 1
                        )
                      : 0
                  }}
                </div>
                <div class="info_text">相对湿度</div>
                <div class="info_text">(%RH)</div>
              </div>
              <div class="info_item">
                <div class="info_num">{{ weatherInfo.temperature || 0 }}</div>
                <div class="info_text">温度</div>
                <div class="info_text">(℃)</div>
              </div>
            </div>
            <div class="info_line">
              <div class="info_item">
                <div class="info_num">{{ weatherInfo.windspeed || 0 }}</div>
                <div class="info_text">风速平均值</div>
                <div class="info_text">(m/s)</div>
              </div>
              <div class="info_item">
                <div class="info_num" style="font-size: 18px; font-weight: 600">
                  {{ weatherInfo.winddirection || 0 }}
                </div>
                <div class="info_text">风向</div>
                <!-- <div class="info_text" style="color: transparent">(°)</div> -->
              </div>
              <div class="info_item" style="height: 0"></div>
            </div>
            <div class="right_top"></div>
          </div>
          <div class="no_data" v-else>
            <img
              src="../../assets/satistics/icon-no-data.png"
              alt=""
              class="no_data_img"
            />
          </div>
        </div>
      </div>

      <div class="first_pad" style="height: 28%; z-index: 500">
        <img
          src="../../assets/satistics/img-content-back.png"
          alt=""
          class="back_img"
        />
        <div class="pad_title">
          <span class="pad_title_text selected_title">实时水质</span>
        </div>
        <div class="box2" style="height: 68%">
          <div
            style="position: relative; width: 100%; height: 100%"
            v-if="waterInfo"
          >
            <el-carousel
              height="100%"
              arrow="never"
              indicator-position="none"
              autoplay
              loop
            >
              <el-carousel-item v-for="(item, index) in waterInfo" :key="index">
                <div class="water_info">
                  <div class="info_line">
                    <!-- <div class="info_item">
                       <div class="info_num"
                       >{{item.tds||0}}
                       </div>
                       <div class="info_text">tds(mg/L)</div>
                       <div class="info_text"></div>
                       <div class="info_num"
                       >{{item.tds||0}}
                       </div>
                     </div> -->
                    <div class="info_item">
                      <!--                      <div class="info_num " style="color: #61ff33">{{item.cod||0}}-->
                      <div class="info_num" style="color: #61ff33">
                        <span>35</span>
                        <span
                          style="
                            color: #61ff33;
                            font-size: 14px;
                            white-space: nowrap;
                          "
                          >(正常)</span
                        >
                      </div>
                      <div class="info_text">cod(mg/L)</div>
                      <!-- <div class="info_text"></div> -->
                      <!-- <div class="info_num"
                      >{{item.cod||0}}
                      </div> -->
                    </div>
                    <div class="info_item">
                      <!--                      <div class="info_num"-->
                      <!--                      >{{item.ph||0}}-->
                      <!--                      </div>-->
                      <div class="info_num" style="color: #61ff33">
                        <span>7.73</span>
                        <span
                          style="
                            color: #61ff33;
                            font-size: 14px;
                            white-space: nowrap;
                          "
                          >(正常)</span
                        >
                      </div>
                      <div class="info_text">ph</div>
                      <!-- <div class="info_text" style="color: rgba(0,0,0,0)">(单位)</div> -->
                    </div>
                  </div>
                  <div class="info_line">
                    <div class="info_item">
                      <!--                      <div class="info_num"-->
                      <!--                      >{{item.temperature||0}}-->
                      <!--                      </div>-->
                      <div class="info_num" style="color: #61ff33">
                        <span>14.3</span>
                        <span
                          style="
                            color: #61ff33;
                            font-size: 14px;
                            white-space: nowrap;
                          "
                          >(正常)</span
                        >
                      </div>
                      <div class="info_text">温度(℃)</div>
                      <!-- <div class="info_text">(℃)</div> -->
                    </div>
                    <div class="info_item">
                      <!--                      <div class="info_num"-->
                      <!--                      >{{item.dissolvedOxygen||0}}-->
                      <!--                      </div>-->
                      <div class="info_num last" style="color: #61ff33">
                        <span>0.5</span>
                        <span
                          style="
                            color: #61ff33;
                            font-size: 14px;
                            white-space: nowrap;
                          "
                          >(正常)</span
                        >
                      </div>
                      <div class="info_text last">氨氮(mg/L)</div>

                      <!-- <div class="info_text">(mg/L)</div> -->
                    </div>
                  </div>
                  <div class="info_line">
                    <div class="info_item" style="width: 100%">
                      <!--                      <div class="info_num last"-->
                      <!--                      >{{item.ammoniaNitrogen||0}}-->
                      <!--                      </div>-->
                      <div class="info_num" style="color: #61ff33">
                        <span>5.59</span>
                        <span
                          style="
                            color: #61ff33;
                            font-size: 14px;
                            white-space: nowrap;
                          "
                          >(正常)</span
                        >
                      </div>
                      <div class="info_text">溶解氧(mg/L)</div>
                      <!-- <div class="info_text">(mg/L)</div> -->
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="right_top">
              <!-- <div class="left_time">
                <img src="../../assets/satistics/icon-clock.png" alt="" class="left_time_img">
                <span
                  class="left_time_text">{{waterInfo.createtime?waterInfo.createtime.split(' ')[1]:'00:00:00'}}</span>
              </div> -->
              <div
                class="right_more"
                @click="$router.push('/waterQualityDevice')"
              >
                »
              </div>
            </div>
          </div>
          <div class="no_data" v-else>
            <img
              src="../../assets/satistics/icon-no-data.png"
              alt=""
              class="no_data_img"
            />
          </div>
        </div>
      </div>

      <div class="first_pad" style="height: 30%; z-index: 500">
        <img
          src="../../assets/satistics/img-content-back.png"
          alt=""
          class="back_img"
        />
        <div class="pad_title">
          <span class="pad_title_text selected_title">土壤监测</span>
        </div>
        <div class="box2" style="height: 68%">
          <div class="soil_info" v-if="soilInfo">
            <div class="info_line">
              <div class="info_item">
                <div class="info_num">{{ soilInfo.soilTemperature || 0 }}</div>
                <div class="info_text">土壤温度<br />(℃)</div>
                <!-- <div class="info_text">(℃)</div> -->
              </div>
              <div class="info_item">
                <div class="info_num">{{ soilInfo.soilHumidity || 65 }}</div>
                <div class="info_text">土壤湿度<br />(%)</div>
                <!-- <div class="info_text">(%)</div> -->
              </div>
              <div class="info_item">
                <div class="info_num">{{ soilInfo.temperature || 10 }}</div>
                <div class="info_text">空气温度<br />(℃)</div>
                <!-- <div class="info_text">(℃)</div> -->
              </div>
            </div>
            <div class="info_line">
              <div class="info_item">
                <div class="info_num">{{ soilInfo.humidity || 0 }}</div>
                <div class="info_text">空气湿度<br />(%)</div>
                <!-- <div class="info_text">(%)</div> -->
              </div>
              <div class="info_item">
                <div class="info_num">{{ soilInfo.light.toFixed(0) || 0 }}</div>
                <div class="info_text">光照<br />(KLUX)</div>
                <!-- <div class="info_text">(KLUX)</div> -->
              </div>
              <div class="info_item">
                <div class="info_num">{{ soilInfo.soilN || 0 }}</div>
                <div class="info_text">氮含量<br />(mg/L)</div>
                <!-- <div class="info_text">(mg/L)</div> -->
              </div>
            </div>
            <div class="info_line">
              <div class="info_item">
                <div class="info_num">{{ soilInfo.soilPh || 0 }}</div>
                <div class="info_text">ph</div>
                <!-- <div class="info_text" style="opacity: 0">(mg/L)</div> -->
              </div>
              <div class="info_item">
                <div class="info_num">{{ soilInfo.soilK || 0 }}</div>
                <div class="info_text">钾含量<br />(mg/L)</div>
                <!-- <div class="info_text">(mg/L)</div> -->
              </div>
              <div class="info_item">
                <div class="info_num">{{ soilInfo.soilP || 0 }}</div>
                <div class="info_text">磷含量<br />(mg/L)</div>
                <!-- <div class="info_text">(mg/L)</div> -->
              </div>
            </div>
            <div class="info_line">
              <div class="info_item" style="width: 100%">
                <div class="info_num last">
                  {{ soilInfo.co.toFixed(0) || 0 }}
                </div>
                <div class="info_text last">二氧化碳含量(PPM)</div>
                <!-- <div class="info_text">(PPM)</div> -->
              </div>
            </div>
            <div class="right_top">
              <!-- <div class="left_time">
                <img src="../../assets/satistics/icon-clock.png" alt="" class="left_time_img">
                <span
                  class="left_time_text">{{soilInfo.createTime?soilInfo.createTime.split(' ')[1]:'00:00:00'}}</span>
              </div> -->
              <div
                class="right_more"
                @click="
                  $router.push('/device/SmartAgriculture/smartAgriculture')
                "
              >
                »
              </div>
            </div>
          </div>
          <div class="no_data" v-else>
            <img
              src="../../assets/satistics/icon-no-data.png"
              alt=""
              class="no_data_img"
            />
          </div>
        </div>
      </div>
    </div>

    <video-modal ref="videoModal"></video-modal>
  </div>
</template>

<script>
import { Carousel, CarouselItem, DatePicker, Select, Option } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import vue from "vue";
import * as echart from "echarts";
import VideoJs from "video.js";

vue.use(Carousel);
vue.use(CarouselItem);
vue.use(DatePicker);
vue.use(Select);
vue.use(Option);
// vue.use(Dropdown)
// vue.use(DropdownItem)
// vue.use(DropdownMenu)
// vue.use(Popover)
import ScreenMap from "@/components/map/screenMapMonitor";

export default {
  name: "monitor",
  components: {
    infoPad: () => import("./components/infoPad"),
    infoPad2: () => import("./components/infoPadNoTitle"),
    ecPie: () => import("./components/ec-pie"),
    infoList: () => import("./components/infolist"),
    videoModal: () => import("./components/videokz.vue"),
    ScreenMap,
  },
  data() {
    return {
      offset: {
        x: 0,
        y: 0,
      },
      dragging: false,
      scale: 1, // 初始缩放比例
      photeword2: false,
      photeList: [
        {
          url: require("../../assets/satistics/shebeistatus1.jpg"),
          name: "某摄",
        },
        {
          url: require("../../assets/satistics/shebeistatus2.jpg"),
          name: "某摄",
        },
        {
          url: require("../../assets/satistics/shebeistatus3.jpg"),
          name: "某摄",
        },
        {
          url: require("../../assets/satistics/shebeistatus4.jpg"),
          name: "某摄",
        },
      ], //设备状况图片列表
      videoids: [],
      chosenTitle: ["水质在线监测", "监控摄像"],
      selectedMonth: "",
      gdtotal: {
        dbgd: 0,
        sbyjs: 0,
        sblxs: 0,
      },
      monthSelections: ["2022.06", "2022.07"],
      innerPic: 0,
      weatherInfo: {},
      waterInfo: {
        soilTemperature: 0, // 土壤温度
        soilHumidity: 0, // 土壤湿度
        soilPh: 0, //  ph
        soilN: 0, //  氮
        soilK: 0, // 钾
        soilP: 0, //    磷
        temperature: 0, // 空气温度
        humidity: 0, //  湿度
        light: 0, //   光照
        co: 0, //  二氧化碳
      },
      pieData: [],
      soilInfo: {
        soilTemperature: 0, // 土壤温度
        soilHumidity: 0, // 土壤湿度
        soilPh: 0, //  ph
        soilN: 0, //  氮
        soilK: 0, // 钾
        soilP: 0, //    磷
        temperature: 0, // 空气温度
        humidity: 0, //  湿度
        light: 0, //   光照
        co: 0, //  二氧化碳
      },
      orderList: [],
      showMonitor: false,
      monitorId: [
        "7c6676d68dc74e6b95a83c2746f8895f",
        "89ba5dc34f01485eb34d7c2ba5a921fd",
        "d6601a9959b44f898b260b1b9f70afea",
        "bf4991052d0f4369b65cb8d10a9d2e03",
      ],
      monitorUrl: [],
      equipInfo: {
        light: 0,
        led: 0,
        sensor: 0,
        audio: 0,
        pole: 0,
        camera: 0,
        water: 0,
        farm: 0,
      },
      warningEquip: [0, 0, 0, 0],
      offlineEquip: [0, 0, 0, 0],

      monitorVideo1: null,
      monitorVideo2: null,
      monitorVideo3: null,
      monitorVideo4: null,
      monitorVideo5: null,
      monitorVideo6: null,
      monitorIntervalId: null,

      // 水质监测设备监控
      waterShowMonitor: false,
      waterMonitorVideo1: null,
      waterMonitorVideo2: null,
      waterMonitorVideo3: null,
      waterMonitorIntervalId: null,
      waterMonitorUrl: [],
      waterMonitorId: [],
      tuzhiwaterTimer: null,
      totalTimer: null,
    };
  },

  created() {
    let today = new Date();
    // let month=(today.getMonth() + 1)>9? (today.getMonth() + 1) : '0' + (today.getMonth() + 1)
    this.selectedMonth = this.dayjs().format("YYYY-MM");
    this.getMonthSelection(today);

    Promise.all([
      this.getEquipInfo(),
      this.getSoilInfo(),
      this.getWaterInfo(),
      // this.getPieChart(),
      this.getTodayWeather(),
      this.getOrderList(),
      this.getWaterMonitorData(),
      this.getFarmMonitorData(),
      this.getEquipAmount(),
      this.getMonitorIds("928fd990b1e3483f8847d8f9d1cf7996"),
      this.getMonitorIds("4d642c53186f4737a5504fb65ce834e1"),

      this.getMonitorIdswater("c25ede0c020445ff8092ff377ba12fb5"),
      // this.getMonitorIdswater('134a878a4ffb450aa775154da280273a'),
      // this.getMonitorIdswater('d1fd53ba6278495f8ecd77a25530a87a'),
    ]);
  },

  mounted() {
    // 监听图片大小，防止溢出
    this.$nextTick(() => {
      const boxWidth = this.$refs.image.parentElement.clientWidth;
      const boxHeight = this.$refs.image.parentElement.clientHeight;
      const imageWidth = this.$refs.image.width;
      const imageHeight = this.$refs.image.height;

      // 判断图片是否超出容器
      if (imageWidth > boxWidth || imageHeight > boxHeight) {
        // 根据容器大小等比缩放图片
        const widthRatio = boxWidth / imageWidth;
        const heightRatio = boxHeight / imageHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        this.$refs.image.style.width = imageWidth * ratio + "px";
        this.$refs.image.style.height = imageHeight * ratio + "px";
      }
    });
    this.hkDevice("1503ea22f31c43f1836b352eb722d1a5");
    //    this.monitorId.forEach(item => {
    //      this.getMonitorUrl(item)
    //    })
    // this.monitorId.forEach(item => {
    //   this.getMonitorUrl(item)
    // })
    this.monitorIntervalId = setInterval(() => {
      for (let i = 0; i < 3; i++) {
        let url = this.monitorUrl.shift();
        this.monitorUrl.push(url);
      }
      this.initMonitorVideoController(this.monitorVideo1, this.monitorUrl[0]);
      this.initMonitorVideoController(this.monitorVideo2, this.monitorUrl[1]);
      this.initMonitorVideoController(this.monitorVideo3, this.monitorUrl[2]);
    }, 30000);

    // this.waterMonitorIntervalId = setInterval(() => {
    //   for (let i = 0; i < 3; i++) {
    //     let url = this.waterMonitorUrl.shift()
    //     this.waterMonitorUrl.push(url)
    //   }
    //   this.initMonitorVideoController2(this.waterMonitorVideo1, this.waterMonitorUrl[0]);
    //   this.initMonitorVideoController2(this.waterMonitorVideo2, this.waterMonitorUrl[1]);
    //   this.initMonitorVideoController2(this.waterMonitorVideo3, this.waterMonitorUrl[2]);
    // }, 30000)

    this.tuzhiwaterTimer = setInterval(() => {
      this.getSoilInfo();
      this.getWaterInfo();
    }, 432000000);
    this.totalTimer = setInterval(() => {
      let data1 = this.gdtotal.sbyjs;
      let data2 = this.gdtotal.dbgd;
      this.gdtotal.sbyjs = 0;
      this.gdtotal.dbgd = 0;
      this.plusNum(0, "sbyjs", data1, this.calcStep(data1));
      this.plusNum(0, "dbgd", data2, this.calcStep(data2));
    }, 30000);
  },
  beforeDestroy() {
    this.monitorUrl = [];
    clearInterval(this.monitorIntervalId);
    clearInterval(this.tuzhiwaterTimer);
    clearInterval(this.totalTimer);
    this.monitorIntervalId = null;
    this.monitorVideo1.dispose();
    this.monitorVideo2.dispose();
    this.monitorVideo3.dispose();
    //
    // this.waterMonitorUrl = []
    // clearInterval(this.waterMonitorIntervalId)
    // this.waterMonitorIntervalId = null
    // this.waterMonitorVideo1.dispose()
    // this.waterMonitorVideo2.dispose()
    // this.waterMonitorVideo3.dispose()
  },
  methods: {
    startDrag(e) {
      e.preventDefault();
      this.dragging = true;
      this.offset.x = e.clientX - this.$refs.image.offsetLeft;
      this.offset.y = e.clientY - this.$refs.image.offsetTop;
    },
    onMouseMove(e) {
      if (this.dragging) {
        const moveX = e.clientX - this.offset.x;
        const moveY = e.clientY - this.offset.y;
        this.$refs.image.style.left = moveX + "px";
        this.$refs.image.style.top = moveY + "px";
      }
    },
    endDrag() {
      this.dragging = false;
    },
    handleWheel(e) {
      // 判断滚轮方向，决定缩放比例
      this.scale += e.deltaY > 0 ? 0.1 : -0.1;
      // 设置图片缩放
      this.$refs.image.style.transform = `translate(-50%, -50%) scale(${this.scale})`;
    },
    getMonitorUrl(id) {
      this.$http
        .post("/api/hkDevice/requestHk", {
          url: "/api/video/v1/cameras/previewURLs",
          jsonObject: {
            cameraIndexCode: id,
            protocol: "hls",
            streamType: 1,
          },
        })
        .then((res) => {
          let url = res.data.data.url;
          if (process.env.NODE_ENV != "development") {
            url = "https://lfczhxc.com/hk/" + res.data.data.url.substring(25);
          }
          this.monitorUrl.push(url);
          // if(res.data.length>0){
          // 	let url = res.data.data.url
          // 	if (process.env.NODE_ENV != 'development') {
          // 	  url = "https://lfczhxc.com/hk/" + res.data.data.url.substring(25);
          // 	}
          // 	this.monitorUrl.push(url)
          // }
        });
    },

    closeCamera() {
      this.showMonitor = false;
      this.initMonitorVideoController(this.monitorVideo1, null);
      this.initMonitorVideoController(this.monitorVideo2, null);
      this.initMonitorVideoController(this.monitorVideo3, null);
      // this.monitorVideo1.dispose()
      // this.monitorVideo2.dispose()
      // this.monitorVideo3.dispose()

      // let monitorItem = document.querySelectorAll('.monitor_item')
      // console.log(monitorItem, 'test')
      // monitorItem.forEach((item, index) => {
      //   item.innerHTML = `<Video id="myVideo${index + 1}" class="video-js vjs-default-skin  vjs-big-play-centered monitor_item_img" v-if="monitorUrl.length>${index}" :autoplay="true" preload="auto" style="width: 100%;height: 100%" controlBar="true"><source src="${this.monitorUrl[index]}" style="width: 100%;height: 100%" type="application/x-mpegURL"></video>`
      // })
    },
    openCamera() {
      this.showMonitor = true;
      if (this.waterShowMonitor) {
        this.closeCamerawater();
      }
      setTimeout(() => {
        this.monitorVideo1 = VideoJs("myVideoPlayer1");
        this.monitorVideo2 = VideoJs("myVideoPlayer2");
        this.monitorVideo3 = VideoJs("myVideoPlayer3");
        this.initMonitorVideoController(this.monitorVideo1, this.monitorUrl[0]);
        this.initMonitorVideoController(this.monitorVideo2, this.monitorUrl[1]);
        this.initMonitorVideoController(this.monitorVideo3, this.monitorUrl[2]);
        this.monitorVideo1.load();
        this.monitorVideo2.load();
        this.monitorVideo3.load();
      }, 200);
    },

    getMonitorIds(id) {
      this.$http
        .get(`api/hkDevice/page?&regionId=${id}&currentPage=1&pageSize=100`)
        .then((res) => {
          let list = res.data.data.list;
          list.forEach((item) => {
            this.monitorId.push(item.deviceId);
            this.getMonitorUrl(item.deviceId);
          });
        });
    },

    initMonitorVideoController(minitorName, url) {
      minitorName.src([
        {
          type: "application/x-mpegURL",
          src: url,
        },
      ]);
    },

    closeCamerawater() {
      this.waterShowMonitor = false;
      this.initMonitorVideoController2(this.waterMonitorVideo1, null);
      this.initMonitorVideoController2(this.waterMonitorVideo2, null);
      this.initMonitorVideoController2(this.waterMonitorVideo3, null);
    },
    openCamerawater() {
      this.waterShowMonitor = true;
      if (this.showMonitor) {
        this.closeCamera();
      }

      setTimeout(() => {
        this.waterMonitorVideo1 = VideoJs("myVideoPlayerwater1");
        this.waterMonitorVideo2 = VideoJs("myVideoPlayerwater2");
        this.waterMonitorVideo3 = VideoJs("myVideoPlayerwater3");
        this.initMonitorVideoController2(
          this.waterMonitorVideo1,
          this.waterMonitorUrl[0]
        );
        this.initMonitorVideoController2(
          this.waterMonitorVideo2,
          this.waterMonitorUrl[1]
        );
        this.initMonitorVideoController2(
          this.waterMonitorVideo3,
          this.waterMonitorUrl[2]
        );
        this.waterMonitorVideo1.load();
        this.waterMonitorVideo2.load();
        this.waterMonitorVideo3.load();
      }, 200);
    },
    initMonitorVideoController2(minitorName, url) {
      minitorName.src([
        {
          type: "application/x-mpegURL",
          src: url,
        },
      ]);
    },

    getMonitorIdswater(id) {
      this.$http
        .get(`api/hkDevice/page?&regionId=${id}&currentPage=1&pageSize=100`)
        .then((res) => {
          let list = res.data.data.list;
          list.forEach((item) => {
            this.waterMonitorId.push(item.deviceId);
            this.getMonitorUrlwater(item.deviceId);
          });
        });
    },
    getMonitorUrlwater(id) {
      this.$http
        .post("/api/hkDevice/requestHk", {
          url: "/api/video/v1/cameras/previewURLs",
          jsonObject: {
            cameraIndexCode: id,
            protocol: "hls",
            streamType: 1,
          },
        })
        .then((res) => {
          let url = res.data.data.url;
          if (process.env.NODE_ENV != "development") {
            url = "https://lfczhxc.com/hk/" + res.data.data.url.substring(25);
          }
          this.waterMonitorUrl.push(url);
        });
    },

    changeTitle(index) {
      this.innerPic = index;
      this.getEquipAmount();
    },
    // 添加日期选择
    getMonthSelection(today) {
      let tmpSelect = [];
      let year = today.getFullYear();
      let month = today.getMonth();

      for (let i = 0; i < 6; i++) {
        let month1 = month + 1 > 9 ? month + 1 : "0" + (month + 1);
        tmpSelect.push(year + "-" + month1);
        if (month > 0) {
          month -= 1;
        } else {
          month = 11;
          year -= 1;
        }
      }
      this.monthSelections = tmpSelect;
    },
    // 工单列表
    getOrderList() {
      let gdtype = [
        "1",
        "2",
        "0-1",
        "0-3",
        "0-4",
        "0-4-1",
        "0-4-2",
        "0-4-2",
        "0-4-3",
      ];
      let gdtypecolor = [
        "#3467E7",
        "#0AAAAF",
        "#D8393B",
        "#52C41A",
        "#DB499E",
        "#886BA5",
        "#F18241",
        "#2DA6EA",
        "#9518E4",
      ];
      // 0-4摄像头 0-4-1火点监测告警工单 0-4-2漂浮物监测告警工单
      let jsondata = {
        queryMonthTime: this.selectedMonth,
        typeList: ["0-4", "0-4-1", "0-4-2", "2"],
      };
      this.$http
        .post("api/threeScreen/evn/pageWorkOrder", jsondata)
        .then((res) => {
          if (res.data.code == 200) {
            // this.orderList = res.data.list
            let data = res.data.data.list;
            // this.gdtotal.sbyjs=res.data.data.total
            this.gdtotal.sbyjs = 0;
            this.plusNum(
              0,
              "sbyjs",
              res.data.data.total,
              this.calcStep(res.data.data.total)
            );

            let listArr = [];
            let tmpArr = [];
            data.forEach((item, index) => {
              // item.typeName=item.typeName.split("告警工单")[0]
              //  tmpArr.push(item)
              let items1 = item;
              let index1 = gdtype.findIndex((info) => info === item.type);
              items1["ordercolorindex"] = gdtypecolor[index1];
              tmpArr.push(items1);
              if (index == data.length - 1 || index % 4 == 3) {
                listArr.push(tmpArr);
                tmpArr = [];
              }
            });
            this.orderList = listArr;
          }
        });
      this.getPieChart(jsondata);
      this.getworkOrderToDo(jsondata);
    },
    //工单统计分析
    getPieChart(jsondata) {
      let tempArr = [];
      this.$http
        .post("api/threeScreen/evn/workOrderParse", jsondata)
        .then((res) => {
          if (res.data.code == 200) {
            res.data.data.forEach((item) => {
              let obj = {
                name: item.key,
                value: item.value,
              };

              tempArr.push(obj);
            });
            this.pieData = JSON.parse(JSON.stringify(tempArr));
          }
        });
    },
    // 待办工单数量
    getworkOrderToDo(jsondata) {
      this.$http
        .post("api/threeScreen/evn/workOrderToDo", jsondata)
        .then((res) => {
          if (res.data.code == 200) {
            this.gdtotal.dbgd = 0;
            this.plusNum(
              0,
              "dbgd",
              res.data.data.count,
              this.calcStep(res.data.data.count)
            );
            // this.gdtotal.dbgd=res.data.data.count
          }
        });
    },
    getEquipAmount() {
      this.$http
        .post("api/lamp/get", {
          map: {
            id: "20",
          },
          requestMethod: "/s/tpd/l/sensor/gd",
        })
        .then((res) => {
          let data = JSON.parse(JSON.stringify(res.data.data.data));
          this.equipInfo.sensor = data.sensor;
        });
    },

    getWaterMonitorData() {
      this.$http
        .get("api/tPlatformOne/getDeviceStatistics?type=2")
        .then((res) => {
          console.log(res, "waterres");
          let data = res.data.data;
          this.warningEquip[1] = data.deviceWarningStatistics;
          this.offlineEquip[1] = data.deviceOfflineStatistics;
          this.equipInfo.water = data.deviceStatistics;
        });
    },
    getFarmMonitorData() {
      this.$http
        .get("api/tPlatformOne/getDeviceStatistics?type=3")
        .then((res) => {
          let data = res.data.data;
          console.log(data, "waterres");
          this.warningEquip[2] = data.deviceWarningStatistics;
          this.offlineEquip[2] = data.deviceOfflineStatistics;
          this.equipInfo.farm = data.deviceStatistics;
        });
    },

    getEquipInfo() {},

    getSoilInfo() {
      this.$http
        .get("api/tDeviceAgricultureCount/getDeviceCount")
        .then((res) => {
          if (res.data.code == 200) {
            // this.soilInfo = res.data.data
            this.soilInfo = {
              soilTemperature: 0, // 土壤温度
              soilHumidity: 0, // 土壤湿度
              soilPh: 0, //  ph
              soilN: 0, //  氮
              soilK: 0, // 钾
              soilP: 0, //    磷
              temperature: 0, // 空气温度
              humidity: 0, //  湿度
              light: 0, //   光照
              co: 0, //  二氧化碳
            };
            this.plusNum(
              2,
              "soilTemperature",
              res.data.data.soilTemperature,
              this.calcStep(res.data.data.soilTemperature)
            );
            this.plusNum(
              2,
              "soilHumidity",
              res.data.data.soilHumidity,
              this.calcStep(res.data.data.soilHumidity)
            );
            this.plusNum(
              2,
              "soilPh",
              res.data.data.soilPh,
              this.calcStep(res.data.data.soilPh)
            );
            this.plusNum(
              2,
              "soilN",
              res.data.data.soilN,
              this.calcStep(res.data.data.soilN)
            );
            this.plusNum(
              2,
              "soilK",
              res.data.data.soilK,
              this.calcStep(res.data.data.soilK)
            );
            this.plusNum(
              2,
              "soilP",
              res.data.data.soilP,
              this.calcStep(res.data.data.soilP)
            );
            this.plusNum(
              2,
              "temperature",
              res.data.data.temperature,
              this.calcStep(res.data.data.temperature)
            );
            this.plusNum(
              2,
              "humidity",
              res.data.data.humidity,
              this.calcStep(res.data.data.humidity)
            );
            // this.plusNum(2, "light", res.data.data.light, this.calcStep(res.data.data.light));
            // this.plusNum(2, "co", res.data.data.co, this.calcStep(res.data.data.co));
          }
        });
    },

    getWaterInfo() {
      this.$http.get("api/emScren/getWaterQuality").then((res) => {
        if (res.data.code == 200) {
          // this.waterInfo = res.data.data
          this.waterInfo = [
            {
              tds: 0, // 土壤温度
              cod: 0, // 土壤湿度
              ph: 0, //  ph
              temperature: 0, //  氮
              ammoniaNitrogen: 0, // 钾
              dissolvedOxygen: 0, //    磷
            },
          ];
          this.plusNum(
            1,
            "tds",
            res.data.data[0].tds,
            this.calcStep(res.data.data[0].tds)
          );
          this.plusNum(
            1,
            "cod",
            res.data.data[0].cod,
            this.calcStep(res.data.data[0].cod)
          );
          this.plusNum(
            1,
            "ph",
            res.data.data[0].ph,
            this.calcStep(res.data.data[0].ph)
          );
          this.plusNum(
            1,
            "temperature",
            res.data.data[0].temperature,
            this.calcStep(res.data.data[0].temperature)
          );
          this.plusNum(
            1,
            "ammoniaNitrogen",
            res.data.data[0].ammoniaNitrogen,
            this.calcStep(res.data.data[0].ammoniaNitrogen)
          );
          this.plusNum(
            1,
            "dissolvedOxygen",
            res.data.data[0].dissolvedOxygen,
            this.calcStep(res.data.data[0].dissolvedOxygen)
          );
        }
      });
    },

    getTodayWeather() {
      let datas = { map: { id: "20" }, requestMethod: "s/tpd/l/sensor/gd" };
      this.$http.post("api/lamp/get", datas).then((res) => {
        let data = JSON.parse(JSON.stringify(res.data.data));
        this.weatherInfo = data;
      });
      // this.$http.get('api/emScren/getWeather', {params: datas}).then(res => {
      //   if (res.data.code == 200) {
      //     this.weatherInfo = res.data.data.weather
      //   }
      // })
    },
    /**
     * @description 数字滚动递增
     * @param {String} key - 对象key
     * @param {Number} value - 递增结果值
     * @param {Number} step - 递增步伐
     */
    plusNum(index, key, value, step) {
      var that = this;
      if (index == 0) {
        setTimeout(() => {
          if (parseInt(that.gdtotal[key]) < parseInt(value)) {
            var data = that.gdtotal[key] + step;
            if (data <= value) {
              that.gdtotal[key] = data;
            } else {
              that.gdtotal[key] = value;
            }
            that.plusNum(index, key, value, step);
          } else {
            return;
          }
        }, 100);
      } else if (index == 1) {
        setTimeout(() => {
          if (parseInt(that.waterInfo[0][key]) < parseInt(value)) {
            var data = that.waterInfo[0][key] + step;
            if (data <= value) {
              that.waterInfo[0][key] = data;
            } else {
              that.waterInfo[0][key] = value;
            }
            that.plusNum(index, key, value, step);
          } else {
            return;
          }
        }, 100);
      } else if (index == 2) {
        setTimeout(() => {
          if (parseInt(that.soilInfo[key]) < parseInt(value)) {
            var data = that.soilInfo[key] + step;
            if (data <= value) {
              that.soilInfo[key] = data;
            } else {
              that.soilInfo[key] = value;
            }
            that.plusNum(index, key, value, step);
          } else {
            return;
          }
        }, 100);
      }
    },
    /**
     * @description 计算递增步伐
     */
    calcStep(num) {
      return Math.ceil(num / 20);
    },
    hkDevice(id) {
      this.$http
        .get(
          "api/hkDevice/page?deviceName=&regionId=" +
            id +
            "&currentPage=1&pageSize=10"
        )
        .then((res) => {
          if (res.data.code == 200) {
            res.data.data.list.forEach((item) => {
              this.videoids.push(item);
            });
          }
        });
    },
    handleView(row) {
      this.$refs.videoModal.modal = true;
      this.$refs.videoModal.getData(row);
    },
  },
};
</script>

<style scoped lang="less">
  .first_pad {
    position: relative;
    width: 100%;
    margin: 1.8rem 0;

    .pad_title {
      position: absolute;
      left: 5%;
      top: 5%;
      font-size: 20px;
      color: rgba(73, 169, 255, 1);
      user-select: none;

      .pad_title_text {
        margin: 0 0.8rem;
        cursor: pointer;
      }

      .selected_title {
        font-size: 26px;
        color: #FFFFFF;
        font-family: myTitle;
      }
    }
    .right_pic {
      width: 85%;
      height: 100%;
      overflow: hidden;
      ::v-deep {
        .el-carousel__item {
          height: 100%;
        }
        .el-carousel__indicators {
          bottom: 1.1rem;
        }
      }
    }

    .content_area {
      position: absolute;
      top: 15%;
      left: 50%;
      transform: translate(-50%, 0);
      width: 90%;
      height: 80%;


    }

    .top_right {
      position: absolute;
      right: 5%;
      top: 6%;
    }

    .more_button {
      font-size: 14px;
      color: rgba(0, 247, 255, 1);
      user-select: none;
      cursor: pointer;
    }


    .back_img {
      width: 100%;
      height: 100%;
    }

    .circle_img {
      position: absolute;
      left: 15.5%;
      top: 55%;
      transform: translate(0, -50%);
      width: 40%;
    }

    .gd_list_item {
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      margin: 0.6rem 0.4rem;
      padding: 0.8rem 0.5rem 0.3rem 0.5rem;
      background: rgba(4, 49, 110, 0.4);
      box-sizing: border-box;
      cursor: pointer;

      .gd_list_item_line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.5rem;
        box-sizing: border-box;

        .gd_list_item_type {
          width: 60%;
          // padding: 4px;
          color: #ffffff;
          // text-align: center;
          span {
            background: rgba(50, 101, 225, 0.5);
            border-radius: 5px;
            color: #ffffff;
            padding: 0.2rem 0.4rem;
          }

          // border: 1px solid rgba(49, 206, 255, 1);
          // color: rgba(49, 206, 255, 1);
        }

        .gd_list_item_time {
          color: #ffffff;
          text-align: right;
        }
      }

      .gd_list_item_content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;

        .gd_list_item_title {
          // width:100%;
          text-align: left;
          color: white;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 3;
          // -webkit-box-orient: vertical;
          // overflow: hidden;
          // text-overflow: ellipsis;
        }

        .gd_list_item_status {
          font-size: 14px;
          width: 60px;
          text-align: right;
        }
      }
    }
  }

  .box {
    position: absolute;
    top: 4rem;
    left: 50%;
    transform: translateX(-50%);
    height: 80%;
    width: 88%;
  }

  .box2 {
    position: absolute;
    top: 4rem;
    left: 50%;
    transform: translateX(-50%);
    height: 70%;
    width: 88%;
  }

  .app-container {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;

    .left_pad {
      position: absolute;
      top: 8%;
      left: 0;
      padding: 1.2rem 1rem 2rem 1.5rem;
      height: 92%;
      width: 30%;

      .pie_cake_chart {
        width: 100%;
        height: 100%;
      }

      .equip_info {
        width: 100%;
        height: 10rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .pad_back {
          position: relative;
          background: rgba(22, 41, 73, 1);
          width: 31%;
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          text-align: center;
          align-items: center;

          .equip_num {
            font-family: myNum;
            font-size: 34px;
            // font-weight: bold;
            color: #00F7FF;
            line-height: 45px;
          }

          .equip_text {
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 22px;
          }

          .equip_icon {
            margin-top: 0.8rem;
            width: 45%;
            height: 30%;

            .equip_icon_img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .select_year {
        position: absolute;
        top: -3rem;
        right: 0.5rem;

        .month_picker {
          cursor: pointer;

          ::v-deep {

            .el-input__suffix {
              display: flex;
              align-items: center;
            }

            .el-input__prefix {
              display: none;
            }

            .el-input__inner {
              background: #0E235D !important;
              color: #2ECDFF;
              // background: rgba(9, 59, 143, 1);
              border-color: rgba(25, 77, 164, 1);
              width: 7rem;
              cursor: pointer;
              padding: 4px 12px;
              border-radius: 2px;

              height: 32px;
              // color: #fff;
            }
          }

        }
      }

      .list_item:nth-child(odd) {
        background: rgba(4, 49, 110, 0.65)
      }

      .list_item:nth-child(even) {
        background: rgba(7, 22, 41, 0.65)
      }

      .list_item {
        width: 100%;
        height: 10%;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .list_item_type {
          text-align: center;
          width: 18%;
          padding: 0 0.5rem;
          border: 1px solid;
        }

        .list_item_title {
          width: 65%;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .list_item_status {
          width: 10%;
        }
      }
    }

    .center_pad {
      position: absolute;
      left: 30%;
      top: 10%;
      padding: 0 1.5rem 2rem 1rem;
      height: 90%;
      width: 40%;

      .inner_pad {
        width: 100%;
        height: 100%;
        display: flex;
      }

      .inner_left {
        height: 100%;
        width: 100%;
        /*background: green;*/

        .inner_left_icon {
          width: 100%;
          height: 100%;
        }
      }

      .inner_left_top {
        position: absolute;
        left: 0;
        top: 0;

        .inner_line1 {
          background: rgba(29, 76, 153, 0.2);
          display: flex;
          align-items: center;
          color: #fff;
          padding: 0 1.4rem;
          height: 6.5rem;
          margin-bottom: 1rem;
          position: relative;

          .inner_line1_icon {
            width: 40%;

            .line1_icon_img {
              width: 80%;
            }
          }

          .inner_line1_text {
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 22px;
          }

          .inner_line1_num {
            font-family: myDigib;
            font-size: 42px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 42px;
          }
        }


      }

      .inner_right_top {
        position: absolute;
        right: 0;
        top: 0;

        .inner_line2 {
          width: 100%;
          height: calc(100% - 7.5rem);

          .inner_line2_content {
            height: 210px;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .inner_line2_item {
              background: rgba(29, 76, 153, 0.2);
              /*border: 2px solid #0E223D;*/
              display: flex;
              align-items: center;
              padding: 0.4rem 0.8rem;
              color: #fff;

              .inner_line2_item_icon {
                width: 16%;

                .item_icon_img {
                  width: 100%;
                }
              }

              .inner_line2_item_text {
                flex: 1;
                padding: 0 0.3rem;
                font-size: 16px;
              }

              .inner_line2_item_num {
                padding: 0 0.5rem;
                font-family: myDigib;
                font-size: 32px;
                font-weight: 600;
              }

              .more_img {
                width: 14px;
              }
            }
          }
        }

      }

      .monitor_pad {
        position: absolute;
        bottom: 0;
        width: 100%;
        border-radius: 4px;
        overflow: hidden;

        .monitor_title {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: white;
          padding: 6px 18px;
          background: linear-gradient(90deg, #102B67 0%, #021F5E 100%);
          /*45*/

          .monitor_title_text {
            font-size: 22px;
            font-family: myTitle;
            font-weight: 500;
          }

          i {
            font-size: 24px;
            cursor: pointer;
          }
        }

        .monitor_content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.8rem 0.6rem;
          background: rgba(32, 91, 189, 0.35);

          .monitor_item {
            width: 33%;
            height: 160px;

            .monitor_item_img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .inner_right {
        height: 100%;
        width: 48%;
        padding-left: 0.9rem;

        .inner_line1 {
          width: 100%;
          background: rgba(22, 41, 73, 1);
          display: flex;
          align-items: center;
          color: #fff;
          padding: 0 1.8rem;
          height: 6.5rem;
          margin-bottom: 1rem;
          position: relative;

          .inner_line1_icon {
            width: 20%;
            margin-right: 0.4rem;

            .line1_icon_img {
              width: 100%;

            }
          }

          .inner_line1_text {
            flex: 1;
            font-size: 16px;

          }

          .inner_line1_num {
            font-family: myDigib;
            font-size: 38px;
            font-weight: 600;
          }
        }

        .inner_line2 {
          width: 100%;
          height: calc(100% - 7.5rem);

          .inner_title {
            height: 2.5rem;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .inner_title_text {
              color: rgba(255, 197, 44, 1);
              font-size: 20px;
            }

            .inner_title_pattern {
              width: 65%;
              height: 0.4rem;
              background: linear-gradient(to right,
              transparent 0.1%, transparent 2.5%, rgba(68, 122, 203, 0.02) 2.6%, rgba(68, 122, 203, 0.07) 5%, transparent 5.1%, transparent 7.5%, rgba(68, 122, 203, 0.07) 7.6%, rgba(68, 122, 203, 0.12) 10%,
              transparent 10.1%, transparent 12.5%, rgba(68, 122, 203, 0.12) 12.6%, rgba(68, 122, 203, 0.17) 15%, transparent 15.1%, transparent 17.5%, rgba(68, 122, 203, 0.17) 17.6%, rgba(68, 122, 203, 0.22) 20%,
              transparent 20.1%, transparent 22.5%, rgba(68, 122, 203, 0.22) 22.6%, rgba(68, 122, 203, 0.27) 25%, transparent 25.1%, transparent 27.5%, rgba(68, 122, 203, 0.27) 27.6%, rgba(68, 122, 203, 0.32) 30%,
              transparent 30.1%, transparent 32.5%, rgba(68, 122, 203, 0.32) 32.6%, rgba(68, 122, 203, 0.37) 35%, transparent 35.1%, transparent 37.5%, rgba(68, 122, 203, 0.37) 37.6%, rgba(68, 122, 203, 0.42) 40%,
              transparent 40.1%, transparent 42.5%, rgba(68, 122, 203, 0.42) 42.6%, rgba(68, 122, 203, 0.47) 45%, transparent 45.1%, transparent 47.5%, rgba(68, 122, 203, 0.47) 47.6%, rgba(68, 122, 203, 0.52) 50%,
              transparent 50.1%, transparent 52.5%, rgba(68, 122, 203, 0.52) 52.6%, rgba(68, 122, 203, 0.57) 55%, transparent 55.1%, transparent 57.5%, rgba(68, 122, 203, 0.57) 57.6%, rgba(68, 122, 203, 0.62) 60%,
              transparent 60.1%, transparent 62.5%, rgba(68, 122, 203, 0.62) 62.6%, rgba(68, 122, 203, 0.67) 65%, transparent 65.1%, transparent 67.5%, rgba(68, 122, 203, 0.67) 67.6%, rgba(68, 122, 203, 0.72) 70%,
              transparent 70.1%, transparent 72.5%, rgba(68, 122, 203, 0.72) 72.6%, rgba(68, 122, 203, 0.77) 75%, transparent 75.1%, transparent 77.5%, rgba(68, 122, 203, 0.77) 77.6%, rgba(68, 122, 203, 0.82) 80%,
              transparent 80.1%, transparent 82.5%, rgba(68, 122, 203, 0.82) 82.6%, rgba(68, 122, 203, 0.87) 85%, transparent 85.1%, transparent 87.5%, rgba(68, 122, 203, 0.87) 87.6%, rgba(68, 122, 203, 0.92) 90%,
              transparent 90.1%, transparent 92.5%, rgba(68, 122, 203, 0.92) 92.6%, rgba(68, 122, 203, 0.97) 95%, transparent 95.1%, transparent 97.5%, rgba(68, 122, 203, 0.97) 97.6%, rgba(68, 122, 203, 1) 100%);
            }

          }

          .inner_line2_content {
            width: 100%;
            height: calc(100% - 2.5rem);
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .inner_line2_item {
              width: 100%;
              height: 32%;
              background: rgba(0, 31, 72, 0.65);
              border: 2px solid #0E223D;
              display: flex;
              align-items: center;
              padding: 0 1.8rem;
              color: #fff;

              .inner_line2_item_icon {
                width: 16%;

                .item_icon_img {
                  width: 100%;
                }
              }

              .inner_line2_item_text {
                flex: 1;
                padding: 0 0.5rem;
                font-size: 14px;
              }

              .inner_line2_item_num {
                font-family: myDigib;
                font-size: 32px;
                font-weight: 600;
              }
            }
          }
        }
      }

      .more_button {
        color: rgba(70, 196, 255, 1);
        position: absolute;
        top: -35px;
        right: 0.4rem;
        cursor: pointer;
      }
    }

    .right_pad {
      position: absolute;
      right: 0;
      top: 8%;
      padding: 0 1.5rem 2rem 1rem;
      height: 92%;
      width: 30%;

      .el-carousel {
        height: 100%;
      }

      .water_info {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;


        .info_line {
          height: calc(100% / 3);
          display: flex;
          justify-content: space-between;
          align-items: center;

          .info_item:first-child {
            padding: 0 1.6rem 0 1rem;
          }

          // .info_item:last-child {
          //   padding: 0 1rem 0 1.6rem;
          // }

          .info_item {
            padding: 0 1.6rem 0 1rem;
            width: 49.5%;
            height: 95%;
            background: rgba(30, 72, 142, 0.19);
            text-align: center;
            display: flex;
            // justify-content: space-between;
            align-items: center;

            .info_num {
              text-align: left;
              font-family: myDigib;
              // color: #31bbd0;
              color: #fff;
              font-size: 28px;
              line-height: 36px;

              &.last {
                // flex: 0.4;
              }
            }

            .info_text {
              flex: 1;
              text-align: center;
              // color: #fff;
              color: #D5E6FF;
              font-size: 14px;
              line-height: 16px;

              &.last {
                // flex: 0.6;
              }
            }
          }
        }
      }

      .right_top {
        position: absolute;
        right: 0.6rem;
        top: calc(-23px - 0.6rem);
        transform: translate(0, -50%);
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .left_time {
          display: flex;
          align-items: center;

          .left_time_img {
            width: 24px;
            margin-right: 0.4rem;
          }

          .left_time_text {
            font-size: 20px;
            color: #A5D1FF;
            line-height: 24px;
            letter-spacing: 1px;
            margin-right: 0.6rem;
          }

        }

        .right_more {
          font-size: 18px;
          font-weight: 400;
          color: #00F7FF;
          line-height: 20px;
          cursor: pointer;
        }
      }


      .weather_info {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;


        .info_line {
          height: 32%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .info_item {
            width: 32%;
            height: 100%;
            background: rgba(30, 72, 142, 0.19);
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .info_num {
              font-family: myDigib;
              // color: #31bbd0;
              color: #fff;
              font-size: 28px;
              line-height: 36px;
            }

            .info_text {
              // color: #fff;
              color: #D5E6FF;
              font-size: 14px;
              line-height: 16px;
            }
          }
        }

        .right_top {
          position: absolute;
          right: 0.6rem;
          top: calc(-23px - 0.6rem);
          transform: translate(0, -50%);
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .left_time {
            display: flex;
            align-items: center;

            .left_time_img {
              width: 24px;
              margin-right: 0.4rem;
            }

            .left_time_text {
              font-size: 20px;
              color: #A5D1FF;
              line-height: 24px;
              letter-spacing: 1px;
              margin-right: 0.6rem;
            }

          }

          .right_more {
            font-size: 18px;
            font-weight: 400;
            color: #00F7FF;
            line-height: 20px;
            cursor: pointer;
          }
        }
      }

      .soil_info {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;


        .info_line {
          height: 24%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .info_item {
            width: 32.5%;
            height: 100%;
            background: rgba(30, 72, 142, 0.19);
            padding: 0 0.6rem;
            text-align: center;
            display: flex;
            // justify-content: space-between;
            align-items: center;

            .info_num {
              flex: 1.2;
              text-align: left;
              font-family: myDigib;
              // color: #31bbd0;
              color: #fff;
              font-size: 28px;
              line-height: 36px;

              &.last {
                flex: 0.4;
              }
            }

            .info_text {
              flex: 1;
              text-align: center;
              // color: #fff;
              color: #D5E6FF;
              font-size: 14px;
              line-height: 16px;

              &.last {
                text-align: left;
              }
            }
          }
        }

        .right_top {
          position: absolute;
          right: 0.6rem;
          top: calc(-23px - 0.6rem);
          transform: translate(0, -50%);
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .left_time {
            display: flex;
            align-items: center;

            .left_time_img {
              width: 24px;
              margin-right: 0.4rem;
            }

            .left_time_text {
              font-size: 20px;
              color: #A5D1FF;
              line-height: 24px;
              letter-spacing: 1px;
              margin-right: 0.6rem;
            }

          }

          .right_more {
            font-size: 18px;
            font-weight: 400;
            color: #00F7FF;
            line-height: 20px;
            cursor: pointer;
          }
        }

      }
    }

    .arrow_border_pad {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      width: 100%;
      height: 100%;
      background: linear-gradient(to bottom, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left top no-repeat,
      linear-gradient(to right, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left top no-repeat,
      linear-gradient(to bottom, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right top no-repeat,
      linear-gradient(to left, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right top no-repeat,
      linear-gradient(to top, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left bottom no-repeat,
      linear-gradient(to right, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left bottom no-repeat,
      linear-gradient(to top, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right bottom no-repeat,
      linear-gradient(to left, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right bottom no-repeat;
      background-size: 10px 10px;
    }

    .no_data {
      position: relative;
      width: 100%;
      height: 100%;
      background: rgba(35, 55, 91, 0.4500);

      .no_data_img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 42%;
      }
    }

  }

  .popper__arrow::after {
    top: 0;
  }

  .month_selections {
    .el-select-dropdown__wrap {
      background: rgba(9, 59, 143, 1);

      .el-select-dropdown__list {
        background: rgba(9, 59, 143, 1);
      }

      .el-select-dropdown__item.hover {
        /*background: rgba(59, 119, 207, 1);*/
      }

      .el-select-dropdown__item {
        /*background: rgba(9, 59, 143, 1);*/
        /*color: #fff;*/
      }
    }

    ::v-deep {
    }

  }

  /deep/ .el-select-dropdown {
    background: rgba(40, 82, 163, 0.7);
    border: 1px solid #1060A8;
    z-index: 200;
  }

  /deep/ .el-input__prefix, /deep/ .el-input__suffix {
    color: #587CA0;
  }

  /*// select选择器*/
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: rgba(20, 44, 82, 0.8);
  }

  /deep/ .el-popper[x-placement^=bottom] .popper__arrow:after {
    border-bottom-color: rgba(40, 82, 163, 0.7);
  }

  /deep/ .el-select-dropdown__item.selected {
    // color: #00FDFF;
    color: #2ECDFF;
  }

  .el-select-dropdown__item {
    color: #FFFFFF;
  }

  .videodingwei {
    width: 80%;
    position: absolute;
    top: 18%;
    display: flex;
    // justify-content: space-around;
    margin-left: 10%;

    .videodw {
      width: 2.25rem;
      height: 2.5625rem;
      background: url(../../assets/satistics/img-enviromentdian.png);
      background-size: 100% 100%;
      cursor: pointer;

      &.dw0 {
        margin: 11rem 0 0 0rem;
      }

      &.dw1 {
        margin: 3rem 0 0 0.5rem;
      }

      &.dw2 {
        margin: 5rem 0 0 1.5rem;
      }

      &.dw3 {
        margin: 0rem 0 0 1.5rem;
      }

      &.dw4 {
        margin: 2rem 0 0 1.5rem;
      }

      &.dw5 {
        margin: 5rem 0 0 0.5rem;
      }

      &.dw6 {
        margin: 4rem 0 0 2rem;
      }

      &.dw7 {
        margin: 1rem 0 0 2rem;
      }

      &.dw8 {
        margin: 8rem 0 0 2rem;
      }

      &.dw9 {
        margin: 11rem 0 0 2rem;
      }
    }
  }
</style>

